import React from 'react';
import styled from '@emotion/styled';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { SUBTYPES_FBO } from '../../../../../config';
import InputWrapper from '../../../../common/InputWrapper';
import Button from '../../../../common/Button';
import { useDispatch } from 'react-redux';
import { fetchGetAdminSubtypesFbo, fetchPostSubtypesFbo } from '../../../../../actions/admin';
import { toast } from 'react-toastify';
import { parseError } from '../../../../../helpers';

const Wrapper = styled('div')`
  .text-center {
    width: 100%;
    text-align: center;
  }

  .table .thead-light th:nth-child(n + 2) {
    text-align: center !important;
  }

  .flex-wrapper {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 16px;
    margin-top: 10px;
  }
`;

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Укажите наименование'),
  code: Yup.string().required('Укажите код'),
});

const Info = (props) => {
  const { handleSwitchMode, mode, item, option, setCurrentType } = props;
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      name: item?.name || null,
      code: item?.code || null,
      legalEntityName: item?.legalEntityName || null,
      osgRequirementPercent: item?.osgRequirementPercent || null,
      fbmCode: option,
    },
    enableReinitialize: true,
    validationSchema,
  });

  const { values, setFieldValue } = formik;

  const handleSubmit = () => {
    dispatch(fetchPostSubtypesFbo(values))
      .then(() => {
        toast.info(mode === SUBTYPES_FBO.CREATE ? 'Успешно создано' : 'Успешно сохранено');
        dispatch(fetchGetAdminSubtypesFbo());
        handleSwitchMode(SUBTYPES_FBO.LIST);
        setCurrentType(null);
      })
      .catch((err) => {
        toast.error(parseError(err));
      });
  };

  return (
    <Wrapper>
      <form>
        <div className="flex-wrapper">
          <>
            <Button
              type="button"
              text="&#8592; Отменить изменения и вернуться к списку"
              onClick={() => handleSwitchMode(SUBTYPES_FBO.LIST)}
            />
            <Button type="button" text="Сохранить изменения" onClick={() => handleSubmit()} />
          </>
        </div>

        <div className="form-group" style={{ marginTop: '18px' }}>
          <div className="row" style={{ alignItems: 'flex-end' }}>
            <div className="col-6">
              <InputWrapper
                label="Наименование"
                id="name"
                value={values.name}
                onChange={(e) => setFieldValue('name', e.target.value)}
              />

              <InputWrapper
                labelClassName="mt-1"
                label="Юридическое лицо"
                id="legalEntityName"
                value={values.legalEntityName}
                onChange={(e) => setFieldValue('legalEntityName', e.target.value)}
              />
            </div>

            <div className="col-6">
              <InputWrapper
                label="Код"
                id="code"
                value={values.code}
                onChange={(e) => setFieldValue('code', e.target.value)}
                isDisabled={mode === SUBTYPES_FBO.EDIT}
              />

              <InputWrapper
                labelClassName="mt-1"
                label="ОСГ, %"
                id="osgRequirementPercent"
                value={values.osgRequirementPercent}
                onChange={(e) => setFieldValue('osgRequirementPercent', e.target.value)}
              />
            </div>
          </div>
          <br />
        </div>
      </form>
    </Wrapper>
  );
};

export default Info;
